import React, { useState, useEffect, useContext, useCallback, Fragment } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Regex from 'services/utils/regex/Regex';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import DivLayout from "../../../../components/sales/divLayout/divLayout";
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import ModalPop from 'components/sales/modal/modal';
import { Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

const AddQuotation = ({
    match,
    documentUploadUrlPublic,
    documentUrlDataPublic,
    getMaterialPrice,
    getSolution,
    solution,
    setQuotation
}) => {
    const [isModal, setIsModal] = useState(false);
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [catId, setCatId] = useState(null);
    const [solutionType, setSolutionType] = useState('');
    const [materialId, setMaterialId] = useState(null);
    const [material, setMaterial] = useState([]);
    const [index, setIndex] = useState(0);
    const [price, setPrice] = useState(0);
    const [data, setData] = useState({ lead_id: match.params.id, solution_type_id: '', amc_cost: '', server_charge: '', materials: [{ category: '', material: '', cost: 0, quantity: '', unit_price: '' }] });

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getSolution()
            setIsLoading(false)
        })()
    }, [])
    useEffect(() => {
        if (catId != null) {
            (async () => {
                setIsLoading(true)
                setMaterial(await getSolution(catId))
                setIsLoading(false)
            })()
        }
    }, [catId])
    useEffect(() => {
        if (materialId != null) {
            (async () => {
                setIsLoading(true)
                setPrice(await getMaterialPrice(materialId))
                setIsLoading(false)
            })()
        }
    }, [materialId])

    useEffect(() => {
        if (price[0]?.sale_value != null) {
            const newData = { ...data };
            newData.materials[index].cost = price[0]?.sale_value;
            setData(newData);
        }
    }, [price])

    const headerBtns = () => {
        return (
            <Fragment>
                {solution?.userConfig &&
                    <Button
                        onClick={() => {
                            if (data?.solution_type_id == '' || data?.amc_cost == '' || data?.server_charge == '' || data?.solution_type_id == null || data?.amc_cost == null || data?.server_charge == null) {
                                toast.error('Fill all fields in the quotation block');
                                return
                            }
                            for (let elem in data.materials) {
                                if (data?.materials?.[elem]?.category == '' || data?.materials?.[elem]?.category == null) {
                                    toast.error('Select Catgeory');
                                    return
                                }
                                else if (data?.materials?.[elem]?.material == '' || data?.materials?.[elem]?.material == null) {
                                    toast.error('Select Material for Category');
                                    return
                                }
                                else if (data?.materials?.[elem]?.quantity == '' || data?.materials?.[elem]?.quantity == null || data?.materials?.[elem]?.unit_price == '' || data?.materials?.[elem]?.unit_price == null) {
                                    toast.error('Fill Quantity and Sales Unit');
                                    return
                                }
                            }
                            (async () => {
                                setIsLoading(true)
                                await setQuotation(data)
                                setIsLoading(false)
                            })()
                            setIsModal(true)
                        }}
                        className="filter-hamburger btn btn-transparent"
                    >
                        Submit
                    </Button>
                }
            </Fragment>
        );
    };
    const handleDelete = (index) => {
        if (data?.materials.length > 1) {
            let form = [...data?.materials]
            form.splice(index, 1)
            setData({ ...data, materials: form })
        }

    }
    const handleAdd = () => {
        const form = [...data?.materials]
        form.push({ category: '', material: '', quantity: '', unit_price: '' })
        setData({ ...data, materials: form })
    }
    return (
        <Layout
            title="Project Listing"
            Buttons={headerBtns}
            isGoback
            isLoading={isLoading}
        >
            <div className="panel-card card-details" width="100%">
                <div className="panel-heading">{localization.quotation}</div>
                <div className="panel-body">
                    <div className="details-listing detail_alignment">
                        {solution?.userConfig == false ?
                            <div className='row'>
                                <div className="col-md-12 text-center">
                                    <div className="alert">
                                        <img src={Images?.alert} alt="" />
                                    </div>
                                    <h5>Not allowed to add Quotation. Kindly contact to National Head.</h5>
                                </div>
                            </div>
                            : <>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <DropDownInput
                                            data={solution?.solutionType}
                                            label="Solution Type"
                                            required
                                            errorMsg={localization.requiredName}
                                            getIdValue={(val) => {
                                                setSolutionType(val.value)
                                                setData({ ...data, solution_type_id: val.id })
                                            }}
                                            isStarRequired={true}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <ConstantInput
                                            label='AMC Cost'
                                            regex={Regex.numeric.test(data?.amc_cost)}
                                            value={data?.amc_cost}
                                            type="number"
                                            handleChange={(value) => {
                                                setData({ ...data, amc_cost: value });
                                            }}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    <div className='col-md-6'>
                                        <ConstantInput
                                            label='Server Charge'
                                            regex={Regex.numeric.test(data?.server_charge)}
                                            value={data?.server_charge}
                                            type="number"
                                            handleChange={(value) => {
                                                setData({ ...data, server_charge: value });
                                            }}
                                            isStarRequired={true}
                                        />
                                    </div>
                                </div></>}
                    </div>
                </div>
            </div>
            {solution?.userConfig &&
                <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">{localization.material}</div>
                    <div className="panel-body">

                        {data?.materials.map((element, index) => {
                            return (
                                <div className="details-listing detail_alignment" key={index}>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <DropDownInput
                                                data={solution?.category}
                                                label="Select Category"
                                                required
                                                errorMsg={localization.requiredName}
                                                getIdValue={(val) => {
                                                    const newData = { ...data };
                                                    newData.materials[index].category = val.id;
                                                    setData(newData);
                                                    setCatId(val.id);
                                                }}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        {data?.materials[index]?.category != '' &&
                                            <div className='col-md-6'>
                                                <DropDownInput
                                                    data={material}
                                                    label="Select Material"
                                                    required
                                                    errorMsg={localization.requiredName}
                                                    getIdValue={(val) => {
                                                        const newData = { ...data };
                                                        newData.materials[index].material = val.id;
                                                        setData(newData);
                                                        setMaterialId(val.id)
                                                        setIndex(index);
                                                    }}
                                                    isStarRequired={true}
                                                />
                                            </div>
                                        }
                                    </div>
                                    {data?.materials[index]?.material != '' && <>
                                        <div className='row'>
                                            <div className='col-md-3'>
                                                <ConstantInput
                                                    label='Cost Value'
                                                    disabled={true}
                                                    value={data?.materials[index]?.cost}
                                                    type="text"
                                                />
                                            </div>
                                            <div className='col-md-3'>
                                                <ConstantInput
                                                    label='Quantity'
                                                    regex={Regex.numeric.test(data?.materials[index]?.quantity)}
                                                    value={data?.materials[index]?.quantity}
                                                    type="number"
                                                    handleChange={(value) => {
                                                        const newData = { ...data };
                                                        newData.materials[index].quantity = value;
                                                        setData(newData);
                                                    }}
                                                />
                                            </div>
                                            <div className='col-md-3'>
                                                <ConstantInput
                                                    label='Sales Unit'
                                                    regex={Regex.numeric.test(data?.materials[index]?.unit_price)}
                                                    value={data?.materials[index]?.unit_price}
                                                    type="number"
                                                    handleChange={(value) => {
                                                        const newData = { ...data };
                                                        newData.materials[index].unit_price = value;
                                                        setData(newData);
                                                    }}
                                                />
                                            </div>
                                            <div className='col-md-3'>
                                                <ConstantInput
                                                    label='Total'
                                                    disabled={true}
                                                    value={data?.materials?.[index]?.quantity * data?.materials?.[index]?.unit_price}
                                                    type="text"
                                                />
                                            </div>
                                        </div>
                                    </>}
                                    <div className='row mb-4'>
                                        <button className='btn btn-primary ml-3' onClick={() => handleAdd()}> Add More</button>
                                        <button className='btn btn-danger ml-4' onClick={() => handleDelete(index)} src="https://static.vecteezy.com/system/resources/previews/009/267/401/original/minus-sign-icon-free-png.png">Remove</button>
                                    </div>
                                    {index != data?.materials.length - 1 && <hr />}
                                </div>
                            )
                        })}

                    </div>
                </div>}


            <ModalPop
                title=""
                show={isModal}
                handleModalHide={() => setIsModal(false)}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>Quotation Submitted Successfully</h5>
                    <Link to={`${baseUrl}/project-onboarding/quotations`} className="btn btn-primary mb-4">View Quotations Submitted</Link>
                </div>
            </ModalPop>
        </Layout>
    );
};

export default AddQuotation;
